var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportMonthlyUsageActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "presentation",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "sidebar-icon-rotate",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20169_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 2.8125V15.1875",
    stroke: "#42296E",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 3.9375H5.625C5.31434 3.9375 5.0625 4.18934 5.0625 4.5V7.3125C5.0625 7.62316 5.31434 7.875 5.625 7.875H12.375C12.6857 7.875 12.9375 7.62316 12.9375 7.3125V4.5C12.9375 4.18934 12.6857 3.9375 12.375 3.9375Z",
    stroke: "#42296E",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 10.125H5.625C5.31434 10.125 5.0625 10.3768 5.0625 10.6875V13.5C5.0625 13.8107 5.31434 14.0625 5.625 14.0625H15.1875C15.4982 14.0625 15.75 13.8107 15.75 13.5V10.6875C15.75 10.3768 15.4982 10.125 15.1875 10.125Z",
    stroke: "#42296E",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20169_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportMonthlyUsageActiveIcon);
export default __webpack_public_path__ + "static/media/report_monthly_usage_active_icon.68fdd88319cbe51bf8ab7b50a02fbd28.svg";
export { ForwardRef as ReactComponent };